<div class="main-content-wrap">
    <router-outlet></router-outlet>
</div>
